import { CharacterizationTypeEnum } from './enums';

export class CharacterizeTestedPartyDescription {
  description: string;
  characterizationType = CharacterizationTypeEnum.Description;
}
